import { MOBILE, TABLET } from '@/scripts/constants/media-query'

export class Media {
  private static desktopWidth = Infinity
  private static headerWidth = 1150
  private static tabletWidth = 1024
  private static mobileWidth = 600

  static breakpoints = {
    mobile: Media.mobileWidth,
    tablet: Media.tabletWidth,
    header: Media.headerWidth,
    desktop: Media.desktopWidth,
  }

  static screensCollection = [
    {
      text: 'Desktop',
      width: Media.desktopWidth + 'px',
    },
    {
      text: 'Tablet',
      width: Media.tabletWidth + 'px',
    },
  ]
  // TODO: Fix typo
  static isLessThanDekstop(mqValue: string) {
    return [MOBILE, TABLET].includes(mqValue)
  }

  // TODO: Add other functions for breakpoints
}
